import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import "./Legal.scss"

export const TermsOfServicePage = () => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-component="TermsOfServicePage">
        <main className="legal">

          <h2>Terms of Service</h2>
          <p><strong>Last Updated:</strong> Nov 27, 2024</p>


          <p>Please read these Terms of Service ("Terms") carefully before using <strong>Practice Run AI</strong> by <strong>Hamilton Zell LLC</strong>. By accessing or using the App, you agree to be bound by these Terms.</p>

          <h3>1. Use of the App</h3>
          <ul>
              <li><strong>Eligibility:</strong> You must be at least 18 years old to use the App. By using the App, you confirm that you meet this requirement.</li>
              <li><strong>Account Creation:</strong> You must create an account using LinkedIn to access certain features. You are responsible for the security of your account information.</li>
              <li><strong>Interview Data:</strong> Your practice interview sessions are recorded to generate performance reviews. By using the App, you consent to this recording and acknowledge that the performance reviews are generated automatically.</li>
          </ul>

          <h3>2. Intellectual Property</h3>
          <p>The content, features, and functionality of the App, including all intellectual property rights, are owned by Hamilton Zell LLC. You are granted a limited, non-exclusive, and non-transferable license to use the App for personal and non-commercial purposes.</p>

          <h3>3. Privacy and Data Usage</h3>
          <p>Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, and share your data.</p>

          <h3>4. Limitations of Liability</h3>
          <p>To the extent permitted by law, Hamilton Zell LLC shall not be liable for any damages arising out of or in connection with your use of the App, including but not limited to direct, indirect, incidental, or consequential damages.</p>

          <h3>5. Termination</h3>
          <p>We reserve the right to suspend or terminate your access to the App if you violate these Terms or engage in any activity that disrupts or harms the App or other users.</p>

          <h3>6. Changes to the Terms</h3>
          <p>We may update these Terms to reflect changes in our practices or applicable law. Continued use of the App constitutes acceptance of any changes.</p>

          <p><strong>Contact Us</strong><br/>If you have questions regarding these Terms, please contact us at support@practicerun.ai</p>

      </main>
    </div>
  );
};